import { Injectable } from '@angular/core';
import { Role } from '../models/role.model';
import { ModelFactory } from './model-factory.service';
import { Relationships } from '../models/relationships';

@Injectable()
export class RoleFactory extends ModelFactory<Role> {
  protected resourceName: string = 'role';
  protected resourceNamePlural: string = 'roles';
  protected Model: { new(m: any): Role } = Role;
  protected extractResourceStrategy: (body: any) => {} = this.platformControllerExtractResourceStrategy;
  protected buildResourceStrategy: (model: Role) => {} = this.platformControllerBuildResourceStrategy;
  protected relationships: Relationships = {};
}



// WEBPACK FOOTER //
// ./src/app/resources/factories/role.factory.ts